// src/pages/Dashboard/widgets/OkrKrStatusWidget.tsx
import React, { useEffect, useState } from 'react';
import { Pie, PieConfig } from '@ant-design/plots';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';

interface KrDatum {
    title: string;
    ratio: number;
    color: string;
}

interface OkrKrStatusWidgetProps {
    rowSpan?: number;
    colSpan?: number;
}

const OkrKrStatusWidget: React.FC<OkrKrStatusWidgetProps> = ({
                                                                 rowSpan = 1,
                                                                 colSpan = 1,
                                                             }) => {
    const themeColors = useSelector((state: RootState) => state.app?.themeColors);
    const [data, setData] = useState<KrDatum[]>([]);

    useEffect(() => {
        // Dummy data
        setData([
            { title: 'Tamamlananlar', ratio: 18, color: '#00CCCC' },
            { title: 'Devam Edenler', ratio: 72, color: '#D1E231' },
            { title: 'İptal Edilenler', ratio: 3,  color: '#C0C0C0' },
        ]);
    }, []);

    if (!data.length) return null;

    const config: PieConfig = {
        angleField: 'ratio',
        colorField: 'title',
        // @ts-ignore
        data: data,
        label: {
            text: (d: any) => `${d.ratio}%`,
            position: "inside",
            style: {
                fontWeight: 'bold',
                fill: "#003262",
            },
        },
        scale: {
            color: { range: ['#00CCCC', '#D1E231', '#C0C0C0'] },
        },
        style: {
            stroke: '#fff',
            inset: 1,
            radius: 10,
        },
        legend: {
            color: {
                title: true,
                position: 'bottom',
                rowPadding: 5,
            },
        },
        tooltip: {
            title: 'title',
            items: [{name: '', field: "ratio", valueFormatter: (d: any) => `${d} %`}],
        },
        interaction: {
            elementHighlight: true,
        },
        state: {
            inactive: {opacity: 0.5},
        },
    };

    const size = Math.min(colSpan * 120, rowSpan * 120);
    
    return (
        <div className="h-full w-full p-4 bg-white rounded shadow flex flex-col">
            <h2
                className="text-lg font-semibold text-center mb-4"
            >
                KR Durumları (Hedef Tamamlamalara Göre)
            </h2>
            <div style={{ width: size, height: size, margin: '0 auto' }}>
                <Pie {...config} />
            </div>
        </div>
    );
};

export default OkrKrStatusWidget;
